/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Chat_Import_SuccessInputs */

const en_case_chat_import_success = /** @type {(inputs: Case_Chat_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation imported.`)
};

const pt_br2_case_chat_import_success = /** @type {(inputs: Case_Chat_Import_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversa importada.`)
};

/**
* | output |
* | --- |
* | "Conversation imported." |
*
* @param {Case_Chat_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_chat_import_success = /** @type {((inputs?: Case_Chat_Import_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Chat_Import_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_chat_import_success(inputs)
	return pt_br2_case_chat_import_success(inputs)
});